import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver/FileSaver';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'

import { Documento } from '../_models/documento';
import { Utils } from '../utils';

@Injectable()
export class DocumentoService extends ComponentBaseService {

  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  getServiceName(): string {
    return "DocumentoService";
  }

  /** GET documenti from the server */
  getDocumenti(idAzienda: number, classe: number, tipo: number): Observable<Documento[]> {
    let url = `${ServicesConstants.URL_DOCUMENTI}`;
    url = url + '/?idAzienda=' + idAzienda;

    if (classe != null || tipo != null) {

      if (classe != null)
        url = url + '&classeTipoDocumento=' + classe;

      if (tipo != null) {

        url = url + '&tipoDocumento=' + tipo;
      }
    }

    return this.http.get<Documento[]>(url)
      .pipe(
        tap(finalitaTrattamenti => this.log(`fetched documenti azienda=${idAzienda}, classe=${classe}, tipo=${tipo}`)),
        catchError(this.handleError('getDocumenti', []))
      );
  }

  /** GET Documento by id. */
  getDocumento(id: number): Observable<Documento> {
    const url = `${ServicesConstants.URL_DOCUMENTI}/${id}`;
    return this.http.get<Documento>(url).pipe(
      map(doc => {
        this.log(`fetched Documento id=${id}`);

        doc.nomeFileDocumento = Utils.getDecodedFilename(doc.nomeFileDocumento);

        return doc;
      }),
      catchError(this.handleError<Documento>(`getDocumento id=${id}`))
    )
  }

  /** DELETE: delete the Documento from the server */
  isDocumentoDeletable(documento: Documento | number): Observable<boolean> {
    const id = typeof documento === 'number' ? documento : documento.idDocumento;
    const url = `${ServicesConstants.URL_DOCUMENTI}/${id}/deletable`;

    return this.http.get<boolean>(url, this.httpOptions).pipe(
      tap(_ => this.log(`Deletable Documento id=${id}: ${_}`)),
      catchError(this.handleError<boolean>('isDocumentoDeletable'))
    );
  }

  /** GET FinalitaTrattamento by Classe */
  getDocumentiByClasse(idAzienda: number, classe: number): Observable<Documento[]> {
    return this.getDocumenti(idAzienda, classe, null);
  }

  /** GET FinalitaTrattamento by Tipo */
  getDocumentiByTipo(idAzienda: number, tipo: number): Observable<Documento[]> {
    return this.getDocumenti(idAzienda, null, tipo);
  }

  downloadDocumento(id: number, filename) {
    const url = `${ServicesConstants.URL_DOCUMENTI}/${id}/download`;

    const headers = new HttpHeaders();
    headers.append('Accept', 'text/plain');

    this.http.get(url, { responseType: 'blob' }
    ).subscribe(
      blob => {
        saveAs(blob, filename);
      },
      err => {
        console.error(err);
      });
  }

  /** POST: add a new Documento to the server */
  addDocumento(documento: Documento, file: any): Observable<Documento> {
    let formdata: FormData = new FormData();

    formdata.append('documentoFile', file, Utils.getEncodedFilename(file.name));
    formdata.append('documentoBean', new Blob([JSON.stringify(documento)], { type: "application/json" }));

    return this.http.post<Documento>(ServicesConstants.URL_DOCUMENTI, formdata).pipe(
      tap((documento: Documento) => this.log(`added Documento w/ id=${documento.idDocumento}`)),
      catchError(this.handleError<Documento>('addDocumento'))
    );
  }

  /** DELETE: delete the Documento from the server */
  deleteDocumento(documento: Documento | number): Observable<Documento> {
    const id = typeof documento === 'number' ? documento : documento.idDocumento;
    const url = `${ServicesConstants.URL_DOCUMENTI}/${id}`;

    return this.http.delete<Documento>(url, this.httpOptions).pipe(
      tap(_ => this.log(`deleted Documento id=${id}`)),
      catchError(this.handleError<Documento>('deleteDocumento'))
    );
  }

  /** PUT: update the Documento on the server */
  updateDocumento(documento: Documento): Observable<any> {
    const id = typeof documento === 'number' ? documento : documento.idDocumento;
    const url = `${ServicesConstants.URL_DOCUMENTI}/${id}`;

    return this.http.put(url, documento, this.httpOptions).pipe(
      tap(_ => this.log(`updated Documento id=${id}`)),
      catchError(this.handleError<any>('updateDocumento'))
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/documento.service.ts